import { onBeforeUnmount, onMounted } from 'vue';

type IgnoreElements = string[] | ((element: HTMLElement) => boolean) | undefined;

/**
 * On safari when an input is focused it will open the keyboard, the issue comes
 * when trying to close the keyboard. It will only close the keyboard when
 * another touchable element (with cursor pointer) is clicked.
 * To solve this we need to manually trigger the blur event.
 * @param callback Function to be called when a click is fired and it's outside of the provided id's.
 * @param ignorePattern Ids of the elements we want to ignore or function that returns a boolean.
 */
const useSafariBlur = (callback: () => void, ignorePattern: IgnoreElements) => {
  const handleClickOutsideOfBox = (e: MouseEvent) => {
    const touchedElementId = (e.target as HTMLElement)?.id;

    if (!ignorePattern) {
      callback();
      return;
    }

    if (typeof ignorePattern === 'function' && !ignorePattern(e.target as HTMLElement)) {
      callback();
      return;
    }

    if (Array.isArray(ignorePattern) && !ignorePattern.includes(touchedElementId)) {
      callback();
    }
  };
  onMounted(() => {
    document.addEventListener('click', handleClickOutsideOfBox);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutsideOfBox);
  });
};

export default useSafariBlur;
